<ng-container *ngFor="let widget of data">
	<div class="m-widget1__item" *ngIf="widget.display">
		<div class="row m-row--no-padding align-items-center">
			<div class="col">
				<h3 class="m-widget1__title" style="font-weight:bold;">{{widget.value}}</h3>
				<span class="m-widget1__desc">{{widget.name}}</span>
			</div>
		</div>
	</div>
</ng-container>
